import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import { ButtonContainedLight } from "../../components/UIElements/button";
import { PATH_AUTH } from "../../routes/path";
import VerificationDetails from "../../components/auth/VerificationDetails";
import { useLocation } from "react-router-dom";

const Verification: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isProfileSetupFlow = location.state?.mode === "complete-setup";

  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <Box
      sx={{
        background: "white",
      }}
    >
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{ margin: 3, gap: 4 }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <ButtonContainedLight sx={undefined} onclick={handleBackClick}>
            Back
          </ButtonContainedLight>
          {!isProfileSetupFlow && (
            <Link
              style={{
                color: theme.palette.text.secondary,
                marginLeft: "auto",
                textDecorationLine: "none",
              }}
              to={PATH_AUTH.signIn}
            >
              <Typography
                variant="body2"
                color="primary"
                sx={{
                  fontFamily: "DM Sans",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  letterSpacing: "-0.23999999463558197px",
                  textDecorationLine: "underline",
                }}
              >
                Skip
              </Typography>
            </Link>
          )}
        </Box>
        <Box sx={{ width: "100%" }}>
          <Typography
            color="primary"
            variant="h2"
            sx={{
              fontWeight: 700,
              fontFamily: "DM Sans",
              letterSpacing: "-0.23999999463558197px",
            }}
          >
            {isProfileSetupFlow ? "Complete Setup" : "Verification"}
          </Typography>
          <Typography variant="h5" sx={{ color: theme.palette.text.primary }}>
            {isProfileSetupFlow
              ? "Finish your facility profile"
              : "Join Managed medics"}
          </Typography>
        </Box>

        <VerificationDetails />
      </Stack>
    </Box>
  );
};

export default Verification;
